module.exports = __webpack_public_path__ + "static/media/erv_logo_lg.654575ff.jpg";